"use strict";

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _definitions2;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var Err = require("../util/Errors");

var Consts_1 = require("../util/Consts");

var Parsing_1 = require("../util/Parsing");

var Helpers_1 = require("./Helpers"); // ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// Begin definitions.
// ----------------------------------------------------------------------------
// XPath Constructor functions
// https://www.w3.org/TR/sparql11-query/#
// https://www.w3.org/TR/xpath-functions/#casting-from-primitive-to-primitive
// ----------------------------------------------------------------------------


var toString = {
  arity: 1,
  overloads: Helpers_1.declare().onTerm1(function (term) {
    return Helpers_1.string(term.str());
  }).collect()
};
var toFloat = {
  arity: 1,
  overloads: Helpers_1.declare().onNumeric1(function (val) {
    return Helpers_1.number(val.typedValue);
  }).onBoolean1Typed(function (val) {
    return Helpers_1.number(val ? 1 : 0);
  }).onUnary('string', function (val) {
    var result = Parsing_1.parseXSDFloat(val.str());

    if (!result) {
      throw new Err.CastError(val, Consts_1.TypeURL.XSD_FLOAT);
    }

    return Helpers_1.number(result);
  }).copy({
    from: ['string'],
    to: ['nonlexical']
  }).collect()
};
var toDouble = {
  arity: 1,
  overloads: Helpers_1.declare().onNumeric1(function (val) {
    return Helpers_1.number(val.typedValue, Consts_1.TypeURL.XSD_DOUBLE);
  }).onBoolean1Typed(function (val) {
    return Helpers_1.number(val ? 1 : 0, Consts_1.TypeURL.XSD_DOUBLE);
  }).onUnary('string', function (val) {
    var result = Parsing_1.parseXSDFloat(val.str());

    if (!result) {
      throw new Err.CastError(val, Consts_1.TypeURL.XSD_DOUBLE);
    }

    return Helpers_1.number(result, Consts_1.TypeURL.XSD_DOUBLE);
  }).copy({
    from: ['string'],
    to: ['nonlexical']
  }).collect()
};
var toDecimal = {
  arity: 1,
  overloads: Helpers_1.declare().onNumeric1(function (val) {
    var result = Parsing_1.parseXSDDecimal(val.str());

    if (!result) {
      throw new Err.CastError(val, Consts_1.TypeURL.XSD_DECIMAL);
    }

    return Helpers_1.number(result, Consts_1.TypeURL.XSD_DECIMAL);
  }).copy({
    from: ['integer'],
    to: ['string']
  }).copy({
    from: ['integer'],
    to: ['nonlexical']
  }).onBoolean1Typed(function (val) {
    return Helpers_1.number(val ? 1 : 0, Consts_1.TypeURL.XSD_DECIMAL);
  }).collect()
};
var toInteger = {
  arity: 1,
  overloads: Helpers_1.declare().onBoolean1Typed(function (val) {
    return Helpers_1.number(val ? 1 : 0, Consts_1.TypeURL.XSD_INTEGER);
  }).onNumeric1(function (val) {
    var result = Parsing_1.parseXSDInteger(val.str());

    if (!result) {
      throw new Err.CastError(val, Consts_1.TypeURL.XSD_INTEGER);
    }

    return Helpers_1.number(result, Consts_1.TypeURL.XSD_INTEGER);
  }).copy({
    from: ['integer'],
    to: ['string']
  }).copy({
    from: ['integer'],
    to: ['nonlexical']
  }).collect()
};
var toDatetime = {
  arity: 1,
  overloads: Helpers_1.declare().onUnary('date', function (val) {
    return val;
  }).onUnary('string', function (val) {
    var date = new Date(val.str());

    if (isNaN(date.getTime())) {
      throw new Err.CastError(val, Consts_1.TypeURL.XSD_DATE_TIME);
    }

    return Helpers_1.dateTime(date, val.str());
  }).copy({
    from: ['string'],
    to: ['nonlexical']
  }).collect()
};
var toBoolean = {
  arity: 1,
  overloads: Helpers_1.declare().onNumeric1(function (val) {
    return Helpers_1.bool(val.coerceEBV());
  }).onUnary('boolean', function (val) {
    return val;
  }).onUnary('string', function (val) {
    var str = val.str();

    if (str !== 'true' && str !== 'false') {
      throw new Err.CastError(val, Consts_1.TypeURL.XSD_BOOLEAN);
    }

    return Helpers_1.bool(str === 'true');
  }).copy({
    from: ['string'],
    to: ['nonlexical']
  }).collect()
}; // End definitions.
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------------

var _definitions = (_definitions2 = {}, _defineProperty(_definitions2, Consts_1.TypeURL.XSD_STRING, toString), _defineProperty(_definitions2, Consts_1.TypeURL.XSD_FLOAT, toFloat), _defineProperty(_definitions2, Consts_1.TypeURL.XSD_DOUBLE, toDouble), _defineProperty(_definitions2, Consts_1.TypeURL.XSD_DECIMAL, toDecimal), _defineProperty(_definitions2, Consts_1.TypeURL.XSD_INTEGER, toInteger), _defineProperty(_definitions2, Consts_1.TypeURL.XSD_DATE_TIME, toDatetime), _defineProperty(_definitions2, Consts_1.TypeURL.XSD_DATE, toDatetime), _defineProperty(_definitions2, Consts_1.TypeURL.XSD_BOOLEAN, toBoolean), _definitions2);

exports.namedDefinitions = immutable_1.Map(_definitions);